import React, { useState } from 'react'
import {v4 } from "uuid"
import {IoMdAdd} from "react-icons/io"
import {FiMinus} from "react-icons/fi"
import { updatePost } from '../../utils/Fetch/fetch'
import styles from "./language.module.css"
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import { toast } from 'react-toastify'
import Loader from '../Loader/loader'

const Language = () => {
    const [inputFeilds, setInputFeilds] = useState([
        {lang : "", id : v4()},
    ])
    const [color, setColor] = useState(false)
    const [show, setShow] = useState(false)
        const [showLoader, setShowLoader] = useState(false);


    const handleChangeInput = (id, event) => {
        const newInputFeilds = inputFeilds.map(i => {
          if(id === i.id) {
            i[event.target.name] = event.target.value
          }
          return i;
        })
        
        setInputFeilds(newInputFeilds);
      }

    const handleAddInput = () => {
        if(inputFeilds.length > 2){
            toast("Sorry! only 3 languages are allowed to write")
            return;
        }
        setInputFeilds([...inputFeilds, {lang : "", id : v4()}])
    }

    const handleMinusInput = (index) => {
        const values  = [...inputFeilds];
        values.splice(index, 1)
        setInputFeilds(values)
    }

    const handleSave = async ()=> {
      setShowLoader(true);
      let flag = false
      inputFeilds.forEach((el) => {
        if(el.lang===""){
          flag = true;
        }
      })
      if(flag){
        toast("Please fill the empty language feild")
        setColor(false)
        setShowLoader(false);
        return;
      }
      let payload = inputFeilds.map((el) => {
        return { lang: el.lang }
      })
      const updatedata = async () => {
        let data = await updatePost(JSON.stringify({languages: payload}))
        return data;
      }

      let updatedData = await updatedata()

      if(updatedData.success===true){
        toast("Languages are saved successfully!")
        setColor(true)
        setShow(false)
        setShowLoader(false);
      }else {
        toast("Something went wrong!")
        setShowLoader(false);
      }



    }
  return (
    <div>
        <nav className={styles.profile__nav} onClick={() => setShow(!show)}>
          <h3 style={{color : color===false ? "crimson" : 'grey'}}>
            Languages</h3>
          <span>
            {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
          </span>
        </nav>
        {
          show && <div className={styles.input__box}>
          {  inputFeilds.map((inputObj, index) => (
                <div key={inputObj.id}>
                <input type="text" value={inputObj.lang} placeholder="eg: English"
                onChange={event => handleChangeInput(inputObj.id, event)}
                name="lang"
                />
                <button onClick={() => handleAddInput()}>
                <IoMdAdd />
                </button>
                {
                    index >= 1 && <button style={{marginLeft:"5px"}} onClick={() => handleMinusInput(index)}>
                        <FiMinus />
                    </button>
                }
                </div>
            ))
          }
            <div className={styles.savebtn_box}>
              <button onClick={handleSave}>Save</button>
            </div>
          </div>
        }
        {showLoader && <Loader /> }
    </div>
  )
}

export default Language